export default __webpack_public_path__ + "static/media/galerie3.0a3111cd.png";